import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import parse from "html-react-parser";
import Sidebar from "../../../partials/aside/Sidebar";
import helperSpinner from "../../../../helpers/spinner";
import httpService from "../../../../services/httpServices/httpServices";
import helpersTime from "../../../../helpers/time";
import helpersNumber from "../../../../helpers/numbers";
import TitleBar from "../../../partials/content/TitleBar";
import Pagination from "../../../partials/content/Pagination";

export default function All() {
  const [privateNotification, setPrivateNotification] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [countItemPerPage, setCountItemPerPage] = useState(10);
  const [countPage, setCountPage] = useState(1);

  useEffect(() => {
    getAllNotificationDashboard();
  }, [currentPage, countItemPerPage]);

  const getAllNotificationDashboard = async () => {
    helperSpinner.showSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
    const allNotificationDashboard =
      await sendRequestGetAllNotificationDashboard();
    helperSpinner.removeSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
    if (!allNotificationDashboard) {
      return;
    }

    setPrivateNotification(allNotificationDashboard.private_notifications);
    setCountPage(allNotificationDashboard.count_page);
  };

  const sendRequestNotificationDashboardSeenByUser = (
    notificationDashboardID
  ) => {
    let headersRequest = getHeaderForRequest();
    try {
      httpService.putRequest(
        process.env.REACT_APP_DOMAIN_API +
          `/v1/private-notification/${notificationDashboardID}/seen`,
        {},
        headersRequest
      );
    } catch (error) {
      alert(error.response.data.message);
      return;
    }

    return;
  };

  const paginationItemOnClickHandler = async (e) => {
    if (!e.target.attributes[1]) {
      return;
    }

    setCurrentPage(e.target.attributes[1].value);
  };

  const generatePagination = () => {
    return (
      <div className="py-2 d-flex flex-column flex-md-row  align-items-md-center  ">
        <Pagination
          countPage={countPage}
          currentPage={currentPage}
          paginationItemOnClickHandler={paginationItemOnClickHandler}
        />
      </div>
    );
  };

  const generateAllNotificationDashboard = () => {
    return (
      <div id="notification-dashboard-container">
        {privateNotification.map((item, index) => {
          const borderColor = item.seen ? "success" : "danger";
          return (
            <div id={`accordion-${index + 1}`}>
              <div
                className={`card border-${borderColor} `}
                onClick={(e) => {
                  e.preventDefault();
                  if (item.seen) {
                    return;
                  }
                  sendRequestNotificationDashboardSeenByUser(item.id);
                }}
              >
                <div
                  className="card-header py-4 hover  "
                  id={`heading-${index + 1}`}
                  data-toggle="collapse"
                  data-target={`#collapse-${index + 1}`}
                  aria-expanded="true"
                  aria-controls={`collapse-${index + 1}`}
                >
                  <div className="mb-0 d-flex justify-content-between ">
                    <span>
                      <span>
                        <b>عنوان پیام :</b>
                      </span>
                      <span>{item.title}</span>
                    </span>
                    <span>
                      ارسال شده{" "}
                      {helpersNumber.toPersianNum(
                        helpersTime.convertGregorianToJalali(item.created_at)
                      )}
                    </span>
                  </div>
                </div>

                <div
                  id={`collapse-${index + 1}`}
                  className="collapse"
                  aria-labelledby={`heading-${index + 1}`}
                  data-parent={`#accordion-${index + 1}`}
                >
                  <div className="card-body">
                    <div className="pb-2">
                      <b>متن پیام</b>
                    </div>
                    <div>{parse(item.text)}</div>
                  </div>
                </div>
              </div>
            </div>
          );
        })}
        {countPage > 1 ? generatePagination() : <></>}
      </div>
    );
  };

  const sendRequestGetAllNotificationDashboard = async () => {
    let result;
    let headersRequest = getHeaderForRequest();
    try {
      result = await httpService.getRequest(
        `${process.env.REACT_APP_DOMAIN_API}/v1/private-notification?page=${currentPage}&number=${countItemPerPage}`,
        headersRequest
      );
    } catch (error) {
      alert(error.response.data.message);
      return false;
    }

    return result.data.data;
  };

  const getHeaderForRequest = () => {
    const token = localStorage.getItem("token");
    const headersRequest = {
      headers: {
        authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    };

    return headersRequest;
  };

  const generateUserDoseNotHaveNotificationDashboard = () => {
    return (
      <div className="card">
        <div className="card-body">
          <div class="d-flex flex-column flex-md-row">
            <div class="text-center text-md-right">
              <img class="img-fluid" src="/assets/img/do-not-have-ticket.svg" />
            </div>
            <div class="d-flex flex-column justify-content-center pr-0 pt-3  pr-md-3 pt-md-0">
              <p className="text-justify">شما فعلا هیچ پیام خصوصی ندارید.</p>
            </div>
          </div>
        </div>
      </div>
    );
  };

  return (
    <>
      <Sidebar openItem="users" activeItem="all-notification-private" />

      <div className="content-wrapper">
        <TitleBar title="پیام های خصوصی" />

        <section className="content pt-5">
          {privateNotification.length == 0
            ? generateUserDoseNotHaveNotificationDashboard()
            : generateAllNotificationDashboard()}
        </section>
      </div>
    </>
  );
}
